export const USER = "users";
export const BLOCKED_LIST = "Blocked";
export const CONFIG = "configs";
export const SUB_SCREEN = "configs/game/screens";
export const ADMIN_NOTI = "admin_noti";
export const SCHOOL = "school";